import React from 'react';
import { MealsTab } from '../Hub/Kitchen';

/**
 * MealsWidget - Recipe suggestions widget
 * 
 * Thin wrapper around MealsTab.
 * Shows recipe suggestions based on pantry ingredients and mood.
 * 
 * Receives data from props (passed through from App.js)
 */
export default function MealsWidget({
  // Data
  stockedItems = [],
  currentState = {},
  // Handlers
  onOpenChatWithMessage
}) {
  return (
    <MealsTab
      stockedItems={stockedItems}
      currentState={currentState}
      onOpenChatWithMessage={onOpenChatWithMessage}
    />
  );
}
